import { createIconFromSvg } from '../icons';
import { ReactComponent as PrescriptionsSvg } from './prescriptions.svg';

export const Prescriptions = createIconFromSvg(PrescriptionsSvg, '0 -960 960 960');
